// extracted by mini-css-extract-plugin
export default {"card-labelled-value":"CardLabelledValue_card-labelled-value__Bx3Yl","card-labelled-value__content":"CardLabelledValue_card-labelled-value__content__LIolb"};